import * as React from 'react';
import WordCloud from './word_cloud';
import AgDetail from './agDetail';
// var echarts = require('echarts');
const mockData = {
  "label": "asc_genes",
  "label_disp": "Associated Genes",
  "type": "page",
  "content": [
    {
      "label": "word_string_ele",
      "label_disp": "",
      "type": "element",
      "content": [
        {
          "label": "word_string",
          "label_disp": "",
          "type": "text",
          "content": "SHE, TEAD1, STXBP1, CA1, ZEB2, FLNA, ARX, CDKL5, KCNQ2"
        }
      ]
    },
    {
      "label": "wordcloud_ele",
      "label_disp": "",
      "type": "element",
      "content": [
        {
          "label": "wordcloud",
          "label_disp": "",
          "type": "wordcloud",
          "content": {
            "index": [
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8
            ],
            "columns": [
              "word",
              "value"
            ],
            "columns_type": [
              "text",
              "float"
            ],
            "data": [
              [
                "SHE",
                0
              ],
              [
                "TEAD1",
                1
              ],
              [
                "STXBP1",
                2
              ],
              [
                "CA1",
                3
              ],
              [
                "ZEB2",
                4
              ],
              [
                "FLNA",
                5
              ],
              [
                "ARX",
                6
              ],
              [
                "CDKL5",
                7
              ],
              [
                "KCNQ2",
                8
              ]
            ]
          }
        }
      ]
    },
    {
      "label": "ills_ele",
      "label_disp": "",
      "type": "element",
      "content": [
        {
          "label": "illustration",
          "label_disp": "",
          "type": "text",
          "content": ""
        }
      ]
    },
    {
      "label": "page_group",
      "label_disp": "",
      "type": "group",
      "content": [
        {
          "label": "SHE",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "SHE"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for SHE Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": ""
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "she, left, cleft, retina, retinal, brain, ophthalmological, psychomotor, asymmetry, classic, unilateral, lateral, eye, triad, abnormal, intracranial, neurobiological, magnetic, lesions, syndrome, mri, congenital, infant, seizure, corpus, partial, resonance, infantile, bilateral, asymmetric, imaging, ocular, typical, characteristic, intellectually, defect, described, normal, features, cerebral, malformations, cortical, phenotype, report, defects, malformation, eyes, cyst, eeg, neurons"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "she",
                        1
                      ],
                      [
                        "left",
                        2
                      ],
                      [
                        "cleft",
                        3
                      ],
                      [
                        "retina",
                        4
                      ],
                      [
                        "retinal",
                        5
                      ],
                      [
                        "brain",
                        6
                      ],
                      [
                        "ophthalmological",
                        7
                      ],
                      [
                        "psychomotor",
                        8
                      ],
                      [
                        "asymmetry",
                        9
                      ],
                      [
                        "classic",
                        10
                      ],
                      [
                        "unilateral",
                        11
                      ],
                      [
                        "lateral",
                        12
                      ],
                      [
                        "eye",
                        13
                      ],
                      [
                        "triad",
                        14
                      ],
                      [
                        "abnormal",
                        15
                      ],
                      [
                        "intracranial",
                        16
                      ],
                      [
                        "neurobiological",
                        17
                      ],
                      [
                        "magnetic",
                        18
                      ],
                      [
                        "lesions",
                        19
                      ],
                      [
                        "syndrome",
                        20
                      ],
                      [
                        "mri",
                        21
                      ],
                      [
                        "congenital",
                        22
                      ],
                      [
                        "infant",
                        23
                      ],
                      [
                        "seizure",
                        24
                      ],
                      [
                        "corpus",
                        25
                      ],
                      [
                        "partial",
                        26
                      ],
                      [
                        "resonance",
                        27
                      ],
                      [
                        "infantile",
                        28
                      ],
                      [
                        "bilateral",
                        29
                      ],
                      [
                        "asymmetric",
                        30
                      ],
                      [
                        "imaging",
                        31
                      ],
                      [
                        "ocular",
                        32
                      ],
                      [
                        "typical",
                        33
                      ],
                      [
                        "characteristic",
                        34
                      ],
                      [
                        "intellectually",
                        35
                      ],
                      [
                        "defect",
                        36
                      ],
                      [
                        "described",
                        37
                      ],
                      [
                        "normal",
                        38
                      ],
                      [
                        "features",
                        39
                      ],
                      [
                        "cerebral",
                        40
                      ],
                      [
                        "malformations",
                        41
                      ],
                      [
                        "cortical",
                        42
                      ],
                      [
                        "phenotype",
                        43
                      ],
                      [
                        "report",
                        44
                      ],
                      [
                        "defects",
                        45
                      ],
                      [
                        "malformation",
                        46
                      ],
                      [
                        "eyes",
                        47
                      ],
                      [
                        "cyst",
                        48
                      ],
                      [
                        "eeg",
                        49
                      ],
                      [
                        "neurons",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "TEAD1",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "TEAD1"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for TEAD1 Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": "ZEB2"
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "neuronal, retina, neurodevelopmental, feature, retinal, disorder, defects, chromosome, mutation, mutations, phenotype, infantile, girls, typical, described, corpus, congenital, rare, brain, severe, syndrome, neurobiological, intellectually, asymmetry, ophthalmologist, lateral, eyes, cranial, asymmetric, epilepsies, unilateral, cleft, classically, neurologic, ophthalmological, classical, intracranial, infant, neurons, characteristic, abnormal, neuroimaging, intellectual, phenotypes, encephalopathy, defect, syndromes, phenotypic, psychomotor, malformation"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "neuronal",
                        1
                      ],
                      [
                        "retina",
                        2
                      ],
                      [
                        "neurodevelopmental",
                        3
                      ],
                      [
                        "feature",
                        4
                      ],
                      [
                        "retinal",
                        5
                      ],
                      [
                        "disorder",
                        6
                      ],
                      [
                        "defects",
                        7
                      ],
                      [
                        "chromosome",
                        8
                      ],
                      [
                        "mutation",
                        9
                      ],
                      [
                        "mutations",
                        10
                      ],
                      [
                        "phenotype",
                        11
                      ],
                      [
                        "infantile",
                        12
                      ],
                      [
                        "girls",
                        13
                      ],
                      [
                        "typical",
                        14
                      ],
                      [
                        "described",
                        15
                      ],
                      [
                        "corpus",
                        16
                      ],
                      [
                        "congenital",
                        17
                      ],
                      [
                        "rare",
                        18
                      ],
                      [
                        "brain",
                        19
                      ],
                      [
                        "severe",
                        20
                      ],
                      [
                        "syndrome",
                        21
                      ],
                      [
                        "neurobiological",
                        22
                      ],
                      [
                        "intellectually",
                        23
                      ],
                      [
                        "asymmetry",
                        24
                      ],
                      [
                        "ophthalmologist",
                        25
                      ],
                      [
                        "lateral",
                        26
                      ],
                      [
                        "eyes",
                        27
                      ],
                      [
                        "cranial",
                        28
                      ],
                      [
                        "asymmetric",
                        29
                      ],
                      [
                        "epilepsies",
                        30
                      ],
                      [
                        "unilateral",
                        31
                      ],
                      [
                        "cleft",
                        32
                      ],
                      [
                        "classically",
                        33
                      ],
                      [
                        "neurologic",
                        34
                      ],
                      [
                        "ophthalmological",
                        35
                      ],
                      [
                        "classical",
                        36
                      ],
                      [
                        "intracranial",
                        37
                      ],
                      [
                        "infant",
                        38
                      ],
                      [
                        "neurons",
                        39
                      ],
                      [
                        "characteristic",
                        40
                      ],
                      [
                        "abnormal",
                        41
                      ],
                      [
                        "neuroimaging",
                        42
                      ],
                      [
                        "intellectual",
                        43
                      ],
                      [
                        "phenotypes",
                        44
                      ],
                      [
                        "encephalopathy",
                        45
                      ],
                      [
                        "defect",
                        46
                      ],
                      [
                        "syndromes",
                        47
                      ],
                      [
                        "phenotypic",
                        48
                      ],
                      [
                        "psychomotor",
                        49
                      ],
                      [
                        "malformation",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "STXBP1",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "STXBP1"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for STXBP1 Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": "ARX, CDKL5, FLNA, KCNQ2"
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "mutations, encephalopathy, phenotypes, epileptic, spectrum, mutation, described, infantile, developmental, eeg, severe, report, neurobiological, asymmetry, asymmetric, epilepsies, cranial, retina, neurologic, intellectually, phenotypic, intracranial, cleft, lethal, classically, feature, ophthalmologist, eyes, classic, retinal, abnormal, unilateral, lateral, neurons, cyst, mri, malformation, cysts, eye, ophthalmological, neuronal, lethality, infant, chromosome, neuroimaging, classical, atypical, she, defect, psychomotor"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "mutations",
                        1
                      ],
                      [
                        "encephalopathy",
                        2
                      ],
                      [
                        "phenotypes",
                        3
                      ],
                      [
                        "epileptic",
                        4
                      ],
                      [
                        "spectrum",
                        5
                      ],
                      [
                        "mutation",
                        6
                      ],
                      [
                        "described",
                        7
                      ],
                      [
                        "infantile",
                        8
                      ],
                      [
                        "developmental",
                        9
                      ],
                      [
                        "eeg",
                        10
                      ],
                      [
                        "severe",
                        11
                      ],
                      [
                        "report",
                        12
                      ],
                      [
                        "neurobiological",
                        13
                      ],
                      [
                        "asymmetry",
                        14
                      ],
                      [
                        "asymmetric",
                        15
                      ],
                      [
                        "epilepsies",
                        16
                      ],
                      [
                        "cranial",
                        17
                      ],
                      [
                        "retina",
                        18
                      ],
                      [
                        "neurologic",
                        19
                      ],
                      [
                        "intellectually",
                        20
                      ],
                      [
                        "phenotypic",
                        21
                      ],
                      [
                        "intracranial",
                        22
                      ],
                      [
                        "cleft",
                        23
                      ],
                      [
                        "lethal",
                        24
                      ],
                      [
                        "classically",
                        25
                      ],
                      [
                        "feature",
                        26
                      ],
                      [
                        "ophthalmologist",
                        27
                      ],
                      [
                        "eyes",
                        28
                      ],
                      [
                        "classic",
                        29
                      ],
                      [
                        "retinal",
                        30
                      ],
                      [
                        "abnormal",
                        31
                      ],
                      [
                        "unilateral",
                        32
                      ],
                      [
                        "lateral",
                        33
                      ],
                      [
                        "neurons",
                        34
                      ],
                      [
                        "cyst",
                        35
                      ],
                      [
                        "mri",
                        36
                      ],
                      [
                        "malformation",
                        37
                      ],
                      [
                        "cysts",
                        38
                      ],
                      [
                        "eye",
                        39
                      ],
                      [
                        "ophthalmological",
                        40
                      ],
                      [
                        "neuronal",
                        41
                      ],
                      [
                        "lethality",
                        42
                      ],
                      [
                        "infant",
                        43
                      ],
                      [
                        "chromosome",
                        44
                      ],
                      [
                        "neuroimaging",
                        45
                      ],
                      [
                        "classical",
                        46
                      ],
                      [
                        "atypical",
                        47
                      ],
                      [
                        "she",
                        48
                      ],
                      [
                        "defect",
                        49
                      ],
                      [
                        "psychomotor",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "CA1",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "CA1"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for CA1 Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": ""
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "cortical, lateral, neurons, epilepsy, she, rare, characteristic, left, onset, seizure, features, syndrome, epilepsies, neurobiological, intellectually, asymmetry, retina, cranial, intracranial, cleft, phenotypes, asymmetric, ophthalmologist, lethal, unilateral, classical, neuroimaging, neurologic, ophthalmological, classically, feature, phenotypic, infant, classic, intellectual, eyes, malformation, abnormal, retinal, phenotype, lesions, eeg, neuronal, cysts, lethality, defect, psychomotor, cyst, neurological, encephalopathy"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "cortical",
                        1
                      ],
                      [
                        "lateral",
                        2
                      ],
                      [
                        "neurons",
                        3
                      ],
                      [
                        "epilepsy",
                        4
                      ],
                      [
                        "she",
                        5
                      ],
                      [
                        "rare",
                        6
                      ],
                      [
                        "characteristic",
                        7
                      ],
                      [
                        "left",
                        8
                      ],
                      [
                        "onset",
                        9
                      ],
                      [
                        "seizure",
                        10
                      ],
                      [
                        "features",
                        11
                      ],
                      [
                        "syndrome",
                        12
                      ],
                      [
                        "epilepsies",
                        13
                      ],
                      [
                        "neurobiological",
                        14
                      ],
                      [
                        "intellectually",
                        15
                      ],
                      [
                        "asymmetry",
                        16
                      ],
                      [
                        "retina",
                        17
                      ],
                      [
                        "cranial",
                        18
                      ],
                      [
                        "intracranial",
                        19
                      ],
                      [
                        "cleft",
                        20
                      ],
                      [
                        "phenotypes",
                        21
                      ],
                      [
                        "asymmetric",
                        22
                      ],
                      [
                        "ophthalmologist",
                        23
                      ],
                      [
                        "lethal",
                        24
                      ],
                      [
                        "unilateral",
                        25
                      ],
                      [
                        "classical",
                        26
                      ],
                      [
                        "neuroimaging",
                        27
                      ],
                      [
                        "neurologic",
                        28
                      ],
                      [
                        "ophthalmological",
                        29
                      ],
                      [
                        "classically",
                        30
                      ],
                      [
                        "feature",
                        31
                      ],
                      [
                        "phenotypic",
                        32
                      ],
                      [
                        "infant",
                        33
                      ],
                      [
                        "classic",
                        34
                      ],
                      [
                        "intellectual",
                        35
                      ],
                      [
                        "eyes",
                        36
                      ],
                      [
                        "malformation",
                        37
                      ],
                      [
                        "abnormal",
                        38
                      ],
                      [
                        "retinal",
                        39
                      ],
                      [
                        "phenotype",
                        40
                      ],
                      [
                        "lesions",
                        41
                      ],
                      [
                        "eeg",
                        42
                      ],
                      [
                        "neuronal",
                        43
                      ],
                      [
                        "cysts",
                        44
                      ],
                      [
                        "lethality",
                        45
                      ],
                      [
                        "defect",
                        46
                      ],
                      [
                        "psychomotor",
                        47
                      ],
                      [
                        "cyst",
                        48
                      ],
                      [
                        "neurological",
                        49
                      ],
                      [
                        "encephalopathy",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "ZEB2",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "ZEB2"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for ZEB2 Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": "CDKL5, TEAD1"
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "cranial, phenotypes, intellectual, severe, encephalopathy, mutation, mutations, characteristic, eeg, onset, defects, cerebral, epileptic, malformations, abnormalities, epilepsies, anomalies, congenital, epilepsy, features, syndrome, infantile, corpus, asymmetric, phenotypic, intellectually, neurobiological, unilateral, neurologic, asymmetry, classically, intracranial, ophthalmological, retina, lateral, ophthalmologist, atypical, feature, classical, neurons, cysts, neuroimaging, cleft, lethal, classic, lethality, cyst, eyes, neuronal, eye"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "cranial",
                        1
                      ],
                      [
                        "phenotypes",
                        2
                      ],
                      [
                        "intellectual",
                        3
                      ],
                      [
                        "severe",
                        4
                      ],
                      [
                        "encephalopathy",
                        5
                      ],
                      [
                        "mutation",
                        6
                      ],
                      [
                        "mutations",
                        7
                      ],
                      [
                        "characteristic",
                        8
                      ],
                      [
                        "eeg",
                        9
                      ],
                      [
                        "onset",
                        10
                      ],
                      [
                        "defects",
                        11
                      ],
                      [
                        "cerebral",
                        12
                      ],
                      [
                        "epileptic",
                        13
                      ],
                      [
                        "malformations",
                        14
                      ],
                      [
                        "abnormalities",
                        15
                      ],
                      [
                        "epilepsies",
                        16
                      ],
                      [
                        "anomalies",
                        17
                      ],
                      [
                        "congenital",
                        18
                      ],
                      [
                        "epilepsy",
                        19
                      ],
                      [
                        "features",
                        20
                      ],
                      [
                        "syndrome",
                        21
                      ],
                      [
                        "infantile",
                        22
                      ],
                      [
                        "corpus",
                        23
                      ],
                      [
                        "asymmetric",
                        24
                      ],
                      [
                        "phenotypic",
                        25
                      ],
                      [
                        "intellectually",
                        26
                      ],
                      [
                        "neurobiological",
                        27
                      ],
                      [
                        "unilateral",
                        28
                      ],
                      [
                        "neurologic",
                        29
                      ],
                      [
                        "asymmetry",
                        30
                      ],
                      [
                        "classically",
                        31
                      ],
                      [
                        "intracranial",
                        32
                      ],
                      [
                        "ophthalmological",
                        33
                      ],
                      [
                        "retina",
                        34
                      ],
                      [
                        "lateral",
                        35
                      ],
                      [
                        "ophthalmologist",
                        36
                      ],
                      [
                        "atypical",
                        37
                      ],
                      [
                        "feature",
                        38
                      ],
                      [
                        "classical",
                        39
                      ],
                      [
                        "neurons",
                        40
                      ],
                      [
                        "cysts",
                        41
                      ],
                      [
                        "neuroimaging",
                        42
                      ],
                      [
                        "cleft",
                        43
                      ],
                      [
                        "lethal",
                        44
                      ],
                      [
                        "classic",
                        45
                      ],
                      [
                        "lethality",
                        46
                      ],
                      [
                        "cyst",
                        47
                      ],
                      [
                        "eyes",
                        48
                      ],
                      [
                        "neuronal",
                        49
                      ],
                      [
                        "eye",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "FLNA",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "FLNA"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for FLNA Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": "ARX, CDKL5, KCNQ2, STXBP1"
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "mutation, onset, phenotypic, intellectual, unilateral, defect, spectrum, cerebral, report, bilateral, psychomotor, triad, described, seizure, malformations, developmental, epilepsy, severe, abnormalities, features, syndrome, infantile, neurobiological, classically, epilepsies, intellectually, intracranial, corpus, neurons, asymmetry, eyes, asymmetric, ophthalmologist, retina, cysts, phenotypes, classical, cranial, abnormal, cleft, neurologic, feature, ophthalmological, neuroimaging, infant, atypical, lateral, characteristic, neuronal, cyst"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "mutation",
                        1
                      ],
                      [
                        "onset",
                        2
                      ],
                      [
                        "phenotypic",
                        3
                      ],
                      [
                        "intellectual",
                        4
                      ],
                      [
                        "unilateral",
                        5
                      ],
                      [
                        "defect",
                        6
                      ],
                      [
                        "spectrum",
                        7
                      ],
                      [
                        "cerebral",
                        8
                      ],
                      [
                        "report",
                        9
                      ],
                      [
                        "bilateral",
                        10
                      ],
                      [
                        "psychomotor",
                        11
                      ],
                      [
                        "triad",
                        12
                      ],
                      [
                        "described",
                        13
                      ],
                      [
                        "seizure",
                        14
                      ],
                      [
                        "malformations",
                        15
                      ],
                      [
                        "developmental",
                        16
                      ],
                      [
                        "epilepsy",
                        17
                      ],
                      [
                        "severe",
                        18
                      ],
                      [
                        "abnormalities",
                        19
                      ],
                      [
                        "features",
                        20
                      ],
                      [
                        "syndrome",
                        21
                      ],
                      [
                        "infantile",
                        22
                      ],
                      [
                        "neurobiological",
                        23
                      ],
                      [
                        "classically",
                        24
                      ],
                      [
                        "epilepsies",
                        25
                      ],
                      [
                        "intellectually",
                        26
                      ],
                      [
                        "intracranial",
                        27
                      ],
                      [
                        "corpus",
                        28
                      ],
                      [
                        "neurons",
                        29
                      ],
                      [
                        "asymmetry",
                        30
                      ],
                      [
                        "eyes",
                        31
                      ],
                      [
                        "asymmetric",
                        32
                      ],
                      [
                        "ophthalmologist",
                        33
                      ],
                      [
                        "retina",
                        34
                      ],
                      [
                        "cysts",
                        35
                      ],
                      [
                        "phenotypes",
                        36
                      ],
                      [
                        "classical",
                        37
                      ],
                      [
                        "cranial",
                        38
                      ],
                      [
                        "abnormal",
                        39
                      ],
                      [
                        "cleft",
                        40
                      ],
                      [
                        "neurologic",
                        41
                      ],
                      [
                        "feature",
                        42
                      ],
                      [
                        "ophthalmological",
                        43
                      ],
                      [
                        "neuroimaging",
                        44
                      ],
                      [
                        "infant",
                        45
                      ],
                      [
                        "atypical",
                        46
                      ],
                      [
                        "lateral",
                        47
                      ],
                      [
                        "characteristic",
                        48
                      ],
                      [
                        "neuronal",
                        49
                      ],
                      [
                        "cyst",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "ARX",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "ARX"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for ARX Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": "CDKL5, FLNA, KCNQ2, STXBP1"
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "phenotypes, mutations, encephalopathy, mutation, classical, epileptic, malformation, intellectual, neuronal, defect, onset, infantile, spectrum, phenotype, epilepsy, disorders, malformations, brain, severe, neurobiological, intellectually, ophthalmologist, epilepsies, phenotypic, asymmetry, asymmetric, classically, unilateral, retina, disorder, intracranial, neurologic, cranial, lethal, feature, atypical, ophthalmological, eyes, lateral, neuroimaging, cleft, neurons, retinal, infant, cysts, abnormal, cyst, psychomotor, eye, resonance"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "phenotypes",
                        1
                      ],
                      [
                        "mutations",
                        2
                      ],
                      [
                        "encephalopathy",
                        3
                      ],
                      [
                        "mutation",
                        4
                      ],
                      [
                        "classical",
                        5
                      ],
                      [
                        "epileptic",
                        6
                      ],
                      [
                        "malformation",
                        7
                      ],
                      [
                        "intellectual",
                        8
                      ],
                      [
                        "neuronal",
                        9
                      ],
                      [
                        "defect",
                        10
                      ],
                      [
                        "onset",
                        11
                      ],
                      [
                        "infantile",
                        12
                      ],
                      [
                        "spectrum",
                        13
                      ],
                      [
                        "phenotype",
                        14
                      ],
                      [
                        "epilepsy",
                        15
                      ],
                      [
                        "disorders",
                        16
                      ],
                      [
                        "malformations",
                        17
                      ],
                      [
                        "brain",
                        18
                      ],
                      [
                        "severe",
                        19
                      ],
                      [
                        "neurobiological",
                        20
                      ],
                      [
                        "intellectually",
                        21
                      ],
                      [
                        "ophthalmologist",
                        22
                      ],
                      [
                        "epilepsies",
                        23
                      ],
                      [
                        "phenotypic",
                        24
                      ],
                      [
                        "asymmetry",
                        25
                      ],
                      [
                        "asymmetric",
                        26
                      ],
                      [
                        "classically",
                        27
                      ],
                      [
                        "unilateral",
                        28
                      ],
                      [
                        "retina",
                        29
                      ],
                      [
                        "disorder",
                        30
                      ],
                      [
                        "intracranial",
                        31
                      ],
                      [
                        "neurologic",
                        32
                      ],
                      [
                        "cranial",
                        33
                      ],
                      [
                        "lethal",
                        34
                      ],
                      [
                        "feature",
                        35
                      ],
                      [
                        "atypical",
                        36
                      ],
                      [
                        "ophthalmological",
                        37
                      ],
                      [
                        "eyes",
                        38
                      ],
                      [
                        "lateral",
                        39
                      ],
                      [
                        "neuroimaging",
                        40
                      ],
                      [
                        "cleft",
                        41
                      ],
                      [
                        "neurons",
                        42
                      ],
                      [
                        "retinal",
                        43
                      ],
                      [
                        "infant",
                        44
                      ],
                      [
                        "cysts",
                        45
                      ],
                      [
                        "abnormal",
                        46
                      ],
                      [
                        "cyst",
                        47
                      ],
                      [
                        "psychomotor",
                        48
                      ],
                      [
                        "eye",
                        49
                      ],
                      [
                        "resonance",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "CDKL5",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "CDKL5"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for CDKL5 Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": "ARX, FLNA, KCNQ2, STXBP1, ZEB2"
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "encephalopathy, mutations, epileptic, atypical, severe, mutation, disorder, classical, spectrum, phenotype, neurodevelopmental, onset, phenotypes, epilepsy, infantile, seizure, intellectual, features, syndromes, report, neurological, girls, disorders, developmental, partial, epilepsies, neurobiological, intellectually, neurons, cranial, asymmetric, ophthalmologist, asymmetry, neurologic, phenotypic, classically, retina, unilateral, cleft, intracranial, feature, neuronal, classic, lethal, eyes, lateral, cysts, neuroimaging, infant, defect"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "encephalopathy",
                        1
                      ],
                      [
                        "mutations",
                        2
                      ],
                      [
                        "epileptic",
                        3
                      ],
                      [
                        "atypical",
                        4
                      ],
                      [
                        "severe",
                        5
                      ],
                      [
                        "mutation",
                        6
                      ],
                      [
                        "disorder",
                        7
                      ],
                      [
                        "classical",
                        8
                      ],
                      [
                        "spectrum",
                        9
                      ],
                      [
                        "phenotype",
                        10
                      ],
                      [
                        "neurodevelopmental",
                        11
                      ],
                      [
                        "onset",
                        12
                      ],
                      [
                        "phenotypes",
                        13
                      ],
                      [
                        "epilepsy",
                        14
                      ],
                      [
                        "infantile",
                        15
                      ],
                      [
                        "seizure",
                        16
                      ],
                      [
                        "intellectual",
                        17
                      ],
                      [
                        "features",
                        18
                      ],
                      [
                        "syndromes",
                        19
                      ],
                      [
                        "report",
                        20
                      ],
                      [
                        "neurological",
                        21
                      ],
                      [
                        "girls",
                        22
                      ],
                      [
                        "disorders",
                        23
                      ],
                      [
                        "developmental",
                        24
                      ],
                      [
                        "partial",
                        25
                      ],
                      [
                        "epilepsies",
                        26
                      ],
                      [
                        "neurobiological",
                        27
                      ],
                      [
                        "intellectually",
                        28
                      ],
                      [
                        "neurons",
                        29
                      ],
                      [
                        "cranial",
                        30
                      ],
                      [
                        "asymmetric",
                        31
                      ],
                      [
                        "ophthalmologist",
                        32
                      ],
                      [
                        "asymmetry",
                        33
                      ],
                      [
                        "neurologic",
                        34
                      ],
                      [
                        "phenotypic",
                        35
                      ],
                      [
                        "classically",
                        36
                      ],
                      [
                        "retina",
                        37
                      ],
                      [
                        "unilateral",
                        38
                      ],
                      [
                        "cleft",
                        39
                      ],
                      [
                        "intracranial",
                        40
                      ],
                      [
                        "feature",
                        41
                      ],
                      [
                        "neuronal",
                        42
                      ],
                      [
                        "classic",
                        43
                      ],
                      [
                        "lethal",
                        44
                      ],
                      [
                        "eyes",
                        45
                      ],
                      [
                        "lateral",
                        46
                      ],
                      [
                        "cysts",
                        47
                      ],
                      [
                        "neuroimaging",
                        48
                      ],
                      [
                        "infant",
                        49
                      ],
                      [
                        "defect",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        },
        {
          "label": "KCNQ2",
          "label_disp": "Annotation of Associated Genes",
          "type": "page",
          "content": [
            {
              "label": "title_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "title",
                  "label_disp": "",
                  "type": "text",
                  "content": "KCNQ2"
                }
              ]
            },
            {
              "label": "summary_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Summary for KCNQ2 Gene,",
                  "type": "text",
                  "content": "The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzyme involved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: the conversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR) and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy or autistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015]"
                }
              ]
            },
            {
              "label": "interacts_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "ADSL interacts with other genes associated with Autism as follows,",
                  "type": "text",
                  "content": "ARX, CDKL5, FLNA, STXBP1"
                }
              ]
            },
            {
              "label": "erc_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "text",
                  "label_disp": "Entities representing context(ERC) associated with ADSL(sorted by distance)",
                  "type": "text",
                  "content": "encephalopathy, mutation, epileptic, phenotype, onset, mutations, spectrum, atypical, developmental, neurological, severe, phenotypes, intellectual, infantile, epilepsy, normal, eeg, described, features, disorder, report, neurobiological, intellectually, epilepsies, asymmetric, cranial, classical, asymmetry, ophthalmologist, retina, cleft, neurologic, phenotypic, neurons, unilateral, lethal, eyes, defect, classically, malformation, lethality, feature, intracranial, abnormal, classic, retinal, ophthalmological, cysts, neuroimaging, lateral"
                }
              ]
            },
            {
              "label": "wordcloud_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "wordcloud",
                  "label_disp": "",
                  "type": "wordcloud",
                  "content": {
                    "index": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49
                    ],
                    "columns": [
                      "word",
                      "value"
                    ],
                    "columns_type": [
                      "text",
                      "float"
                    ],
                    "data": [
                      [
                        "encephalopathy",
                        1
                      ],
                      [
                        "mutation",
                        2
                      ],
                      [
                        "epileptic",
                        3
                      ],
                      [
                        "phenotype",
                        4
                      ],
                      [
                        "onset",
                        5
                      ],
                      [
                        "mutations",
                        6
                      ],
                      [
                        "spectrum",
                        7
                      ],
                      [
                        "atypical",
                        8
                      ],
                      [
                        "developmental",
                        9
                      ],
                      [
                        "neurological",
                        10
                      ],
                      [
                        "severe",
                        11
                      ],
                      [
                        "phenotypes",
                        12
                      ],
                      [
                        "intellectual",
                        13
                      ],
                      [
                        "infantile",
                        14
                      ],
                      [
                        "epilepsy",
                        15
                      ],
                      [
                        "normal",
                        16
                      ],
                      [
                        "eeg",
                        17
                      ],
                      [
                        "described",
                        18
                      ],
                      [
                        "features",
                        19
                      ],
                      [
                        "disorder",
                        20
                      ],
                      [
                        "report",
                        21
                      ],
                      [
                        "neurobiological",
                        22
                      ],
                      [
                        "intellectually",
                        23
                      ],
                      [
                        "epilepsies",
                        24
                      ],
                      [
                        "asymmetric",
                        25
                      ],
                      [
                        "cranial",
                        26
                      ],
                      [
                        "classical",
                        27
                      ],
                      [
                        "asymmetry",
                        28
                      ],
                      [
                        "ophthalmologist",
                        29
                      ],
                      [
                        "retina",
                        30
                      ],
                      [
                        "cleft",
                        31
                      ],
                      [
                        "neurologic",
                        32
                      ],
                      [
                        "phenotypic",
                        33
                      ],
                      [
                        "neurons",
                        34
                      ],
                      [
                        "unilateral",
                        35
                      ],
                      [
                        "lethal",
                        36
                      ],
                      [
                        "eyes",
                        37
                      ],
                      [
                        "defect",
                        38
                      ],
                      [
                        "classically",
                        39
                      ],
                      [
                        "malformation",
                        40
                      ],
                      [
                        "lethality",
                        41
                      ],
                      [
                        "feature",
                        42
                      ],
                      [
                        "intracranial",
                        43
                      ],
                      [
                        "abnormal",
                        44
                      ],
                      [
                        "classic",
                        45
                      ],
                      [
                        "retinal",
                        46
                      ],
                      [
                        "ophthalmological",
                        47
                      ],
                      [
                        "cysts",
                        48
                      ],
                      [
                        "neuroimaging",
                        49
                      ],
                      [
                        "lateral",
                        50
                      ]
                    ]
                  }
                }
              ]
            },
            {
              "label": "word_ills_ele",
              "label_disp": "",
              "type": "element",
              "content": [
                {
                  "label": "illustration",
                  "label_disp": "",
                  "type": "text",
                  "content": "一段用来解释词云的文字"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      word_string: [], // 具体要显示的内容
      word_cloud: [], // 具体要显示的内容
      moreVis: false,
      wordPrefix20: [],
      str: null,
      adslData: null,
      data: null,
      detailVis: false,
      detailData: null,
      selectedObj: null,
    };
  }
  UNSAFE_componentWillMount() {
    console.log(mockData);
    if (this.props.data) {
      this.setState({ content: this.props.data.content, data: this.props.data }, () => {
        this.findData();
      });
    }
    // this.setState({
    //   data: mockData,
    //   content: mockData.content,
    // }, () => {
    //   this.findData();
    // });
  }

  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data) {
      this.setState({ content: this.props.data.content, data: this.props.data }, () => {
        this.findData();
      });
    }
  }

  // 查找要显示的内容
  findData = () => {
    let content = this.state.content;
    // console.log('content: ', content);
    if (content && content.length > 0) {
      let find = content.find(v => { return v.label === 'word_string_ele' });
      if (find && find.content && find.content.length > 0) {
        let find2 = find.content.find(y => { return y.label === 'word_string' });
        if (find2) {
          if (find2 && find2.content && find2.content.length > 0) {
            let allWords = find2.content.split(',');
            let wordPrefix20 = [];
            if (allWords && allWords.length > 20) {
              wordPrefix20 = allWords.slice(0, 20); // 截取前20条
            }
            this.setState({ word_string: allWords, wordPrefix20 }, () => {
              //  console.log(this.state.data);
            });
          }
        }
      }
      let findword_cloud = content.find(v => { return v.label === 'wordcloud_ele' });
      if (findword_cloud && findword_cloud.content && findword_cloud.content.length > 0) {
        let findwordcloud = findword_cloud.content.find(y => { return y.label === 'wordcloud' });
        if (findwordcloud) {
          if (findwordcloud && findwordcloud.content && findwordcloud.content.data && findwordcloud.content.data.length > 0) {
            let originData = findwordcloud.content.data;
            originData = originData.map(v => { return { name: v[0], value: v[1] } });

            this.setState({ word_cloud: originData }, () => {
              // console.log('word_cloud: ', this.state.word_cloud);
            });
          }
        }
      }
      let findElse = content.find(v => { return v.label === 'ills_ele' });
      if (findElse && findElse.content && findElse.content.length > 0) {
        let str = findElse.content.find(y => { return y.label === 'illustration' });
        if (str && str.content) {
          this.setState({ str: str.content });
        }
      }
      let findpage_group = content.find(v => { return v.label === 'page_group' });
      // console.log('findpage_group: ', findpage_group);
      this.setState({ detailData: findpage_group });
    }
  }
  moreClick = () => {
    this.setState({ moreVis: !this.state.moreVis });
  }
  todetail = (word) => {
    let detailData = this.state.detailData;
    word = word.trim();
    if (detailData && detailData.content && detailData.content.length > 0) {
      let find = detailData.content.find((v) => { return v.label === word });
      if (find) {
        this.setState({ detailVis: true, selectedObj: find });
      } else {
        this.setState({ detailVis: false, selectedObj: null });
      }
    } else {
      this.setState({ detailVis: false, selectedObj: null });
    }

  }
  todIndex = () => {
    this.setState({ detailVis: false });
  }
  render() {
    const { word_string, wordPrefix20, moreVis, detailData } = this.state;
    const findSingleWrod = (word) => {
      word = word.trim();
      if (detailData && detailData.content && detailData.content.length > 0) {
        let find = detailData.content.find((v) => { return v.label === word });
        if (find) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    const getWordStr = () => {
      let str = [];
      if (word_string && word_string.length > 0) {
        if (word_string.length > 20) { // 超过20条
          for (let index = 0; index < wordPrefix20.length; index++) {
            const word = wordPrefix20[index];
            if (findSingleWrod(word)) {
              str.push(
                <a onClick={() => { this.todetail(word); }}>{word}</a>
              );
            } else {
              str.push(<span>{word}</span>);
            }
          }
        } else { // 小于20条
          for (let index = 0; index < word_string.length; index++) {
            const word = word_string[index];
            if (findSingleWrod(word)) {
              str.push(
                <a key={index} onClick={() => { this.todetail(word); }}>{word}</a>
              );
            } else {
              str.push(<span key={index}>{word}</span>);
            }
          }
        }
      }
      // console.log(str);
      return (<p>{str}</p>);
    };
    return (
      <React.Fragment>
        {
          !this.state.detailVis &&
          <React.Fragment>
            {
              this.state.word_string &&
              <div className="content">
                <div className="title">{this.state.data.label_disp}</div>
                <div className="cnt">
                  {getWordStr()}
                  {
                    wordPrefix20.length > 0 &&
                    <div className="more">
                      {
                        !moreVis &&
                        <div className="plus" onClick={this.moreClick}></div>
                      }
                      {
                        moreVis &&
                        <div className="minus" onClick={this.moreClick}></div>
                      }
                    </div>
                  }
                  {
                    this.state.word_cloud && this.state.word_cloud.length > 0 &&
                    <WordCloud word_cloud={this.state.word_cloud} />
                  }
                  <p>{this.state.str}</p>
                </div>
              </div>
            }
          </React.Fragment>
        }
        {
          this.state.detailVis &&
          <div className="content has-child">
            <div className="child">
              <AgDetail
                data={this.state.detailData}
                todIndex={this.todIndex}
                leftTitle={this.state.data.label_disp}
                selectedObj={this.state.selectedObj}
              />
            </div>
          </div>
        }
      </React.Fragment>
    );
  }
}

export default Summary;